import React from 'react';
import './App.scss';

import About from './components/About';
import Education from './components/Education';
import Experience from './components/Experience';
import Footer from './components/Footer';
import Header from './components/Header';
import Projects from './components/Projects';
import Skills from './components/Skills';

import resumeData from './res_primaryLanguage.json';
import sharedData from './portfolio_shared_data.json';

function App() {
    const { basic_info, skill_array, skills } = sharedData;
    const { resume_basic_info, projects, education, experience } = resumeData;
    return (
        <div>
            <Header sharedData={basic_info} resume_download={resume_basic_info.resume_download} />
            <About
                profilePic={'images/' + basic_info.image}
                sectionName={resume_basic_info.section_name.about}
                descriptionHeader={resume_basic_info.description_header}
                description={resume_basic_info.description}
            />
            <Education sectionName={resume_basic_info.section_name.education} education={education} />
            <Projects sectionName={resume_basic_info.section_name.projects} projects={projects} />
            <Skills sectionName={resume_basic_info.section_name.skills} skills={skills} skillsList={skill_array} />
            <Experience sectionName={resume_basic_info.section_name.experience} experience={experience} />
            <Footer basicInfo={basic_info} />
        </div>
    );
}

export default App;
